import {
    BlurEvent,
    ChangeEvent,
    EditRowDecorator,
    Switch,
    TableRow,
    TableRowDisplayEvent,
    TableRowMode,
    Textbox
} from "@mcleod/components";
import {AutogenLayoutTableDrivers} from "./autogen/AutogenLayoutTableDrivers";
import {ModelRow, StringUtil} from "@mcleod/core";
import {SmsService} from "@mcleod/powerbroker/src/sms/SmsService";


export class TableDrivers extends AutogenLayoutTableDrivers {

    private smsOptInDefault: boolean = false;

    async onLoad() {
        this.tableDrivers.onEditLayoutLoaded = this.onEditLayoutLoadedDriver();
        this.smsOptInDefault = await SmsService.getDefaultSmsOptIn();


    }

    tableDriversOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if(tableRow.mode === TableRowMode.QUICK_ADD){
            const switchSmsOptIn = tableRow.findComponentById("switchSMSOptIn") as Switch;
            if(switchSmsOptIn){
                switchSmsOptIn.checked = this.smsOptInDefault;
            }
        }else{
            const switchSmsOptIn = tableRow.findComponentById("switchSMSOptIn") as Switch;
            const textboxCountryCode = tableRow.findComponentById("textboxCountryCode") as Textbox;
            if(switchSmsOptIn && textboxCountryCode){
                if (!StringUtil.isEmptyString(textboxCountryCode.text) && StringUtil.equalsIgnoreCase(textboxCountryCode.text, "+52")) {
                    switchSmsOptIn.tooltip = "SMS messages cannot be sent to phone numbers with the +52 (Mexico) country code.";
                }else{
                    switchSmsOptIn.tooltip = "Recipient must consent to receive messages. Once opted in, a confirmation text is sent automatically.";
                }
            }
        }
    }

    textboxCountryCodeOnChange(event: ChangeEvent){
        if(event.userInitiatedChange){
            const textboxCountryCode = event.target as Textbox;
            const tableRow = TableRow.getContainingTableRow(textboxCountryCode);
            const switchSmsOptIn = tableRow.findComponentById("switchSMSOptIn") as Switch;
            if(switchSmsOptIn) {
                if (!StringUtil.isEmptyString(textboxCountryCode.text) && StringUtil.equalsIgnoreCase(textboxCountryCode.text, "+52")) {
                    switchSmsOptIn.tooltip = "SMS messages cannot be sent to phone numbers with the +52 (Mexico) country code.";
                }else{
                    switchSmsOptIn.tooltip = "Recipient must consent to receive messages. Once opted in, a confirmation text is sent automatically.";
                }
            }
        }
    }

    onEditLayoutLoadedDriver(): (rowDecorator: EditRowDecorator, tableRow: TableRow) => void {
        return (rowDecorator: EditRowDecorator, tableRow: TableRow) => {
            if (rowDecorator.btnDelete) {
                rowDecorator.btnDelete.visible = false;
            }
        };
    }

    switchSmsOptInOnChange(event: ChangeEvent){
        const today = new Date();
        const optInSwitch = event.target as Switch;
        const tableRow = TableRow.getContainingTableRow(optInSwitch);
        const textboxOptOutDate = tableRow.findComponentById("textboxOptOutDate") as Textbox;
        if(textboxOptOutDate !== undefined){
            if(optInSwitch.checked) {
                textboxOptOutDate.clear();
            }else{
                textboxOptOutDate.text = today.toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric'
                });
            }
        }
    }

    textboxOptOutDateOnBlur(event: BlurEvent){
        const textboxOptOutDate = event.target as Textbox;
        const tableRow = TableRow.getContainingTableRow(textboxOptOutDate);
        const optInSwitch = tableRow.findComponentById("switchSMSOptIn") as Switch;
        if (!StringUtil.isEmptyString(textboxOptOutDate.text)) {
            const optOutDate = new Date(textboxOptOutDate.text);
            const currentDate = new Date();
            if (optOutDate <= currentDate) {
                optInSwitch.checked = false;
            }
        }
    }

    setEnableTrackingFieldsVisibility(visible: boolean) {
        const column = this.tableDrivers.getColumnByCaption("Country Code");
        if (column && !visible) {
            this.tableDrivers.removeColumn(column);
        }
    }
}
